import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';
import {
  baseUniDriverFactory,
  findByHook,
} from '../test-utils/utils/unidriver';
import { tooltipDriverFactory } from '../Tooltip/Tooltip.uni.driver';
import { dataHooks } from './constants';

export const checkToggleDriverFactory = (base: UniDriver, body: UniDriver) => {
  const getTooltipDriver = () =>
    tooltipDriverFactory(findByHook(base, dataHooks.tooltip), body);

  return {
    ...baseUniDriverFactory(base),

    // Checks whether CheckToggle is checked
    isChecked: (): Promise<boolean> =>
      findByHook(base, dataHooks.toggle)._prop('checked'),

    // Clicks on the element
    click: async () => {
      const input = await findByHook(base, dataHooks.toggle);

      // eslint-disable-next-line no-restricted-properties
      const isDisabled = await input._prop('disabled');

      // In order to simulate a real user event, we need to check if the input is disabled before clicking.
      if (!isDisabled) await input.click();
    },

    //  Gets the tooltip content, throws an error if content is not provided.
    getTooltipContent: async (): Promise<string> => {
      const tooltipDriver = getTooltipDriver();
      if (await tooltipDriver.exists()) {
        await tooltipDriver.mouseEnter();
        const text = await tooltipDriver.getTooltipText();

        if (typeof text === 'string') {
          return text;
        }
      }

      throw new Error(`Message was not provided`);
    },
  };
};

export type CheckToggleUniDriver = ReturnType<typeof checkToggleDriverFactory>;
